import { useLingui } from "@lingui/react/macro";
import { X } from "lucide-react";

import { DataAdd } from "../../../../models/data-add";
import { Button } from "../../button";

export function CellRemoveButton({
  model,
  index,
}: {
  model: DataAdd;
  index: number;
}) {
  const { t } = useLingui();
  return (
    <div className="flex justify-center">
      <Button
        variant="tertiary"
        destructive
        size="sm"
        icon={X}
        label={t`Remove`}
        onClick={() => {
          model.removeItem(index);
        }}
      />
    </div>
  );
}
